import { render } from "./Capsule.vue?vue&type=template&id=0c049972&scoped=true"
import script from "./Capsule.vue?vue&type=script&lang=js"
export * from "./Capsule.vue?vue&type=script&lang=js"

import "./Capsule.vue?vue&type=style&index=0&id=0c049972&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\dragoncrew\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c049972"]])

export default __exports__